export enum InvestmentProductGroup {
    Managed = "Managed",
    Series = "Series",
    Models = "Models",
    Availability = "Availability",
    ESG = "ESG",
    BDM = "Find BDM",
}
